var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29729 1.36386C9.52831 1.42521 9.72186 1.58281 9.82875 1.7966C10.2317 2.60253 10.5325 3.09167 10.835 3.48827C11.1413 3.88971 11.4653 4.21834 11.9581 4.71116C13.097 5.85003 13.6667 7.34437 13.6666 8.83596C13.6666 10.3275 13.097 11.8219 11.9581 12.9607C9.68005 15.2388 5.9866 15.2388 3.70854 12.9607C2.56968 11.8219 2 10.3275 2 8.83596C2 7.34437 2.56967 5.85003 3.70854 4.71116C3.94687 4.47283 4.3053 4.40154 4.6167 4.53052C4.92809 4.6595 5.13113 4.96337 5.13113 5.30042C5.13113 6.2336 5.1894 6.94464 5.46234 7.51179C5.61242 7.82365 5.84654 8.12855 6.25003 8.40063C6.3464 7.51666 6.52292 6.43966 6.76145 5.41741C6.94925 4.61256 7.18282 3.80904 7.46082 3.13898C7.59987 2.80384 7.75712 2.48472 7.9357 2.20919C8.10953 1.941 8.33287 1.66809 8.62115 1.4759C8.82003 1.34331 9.06627 1.30251 9.29729 1.36386ZM9.60109 12.2704C8.62478 13.2467 7.04187 13.2467 6.06556 12.2704C5.57741 11.7822 5.33333 11.1424 5.33333 10.5026C5.33333 10.5026 6.06556 10.9192 7.4167 10.9192C7.4167 10.0859 7.83336 7.58593 8.45836 7.16926C8.87503 8.00259 9.11293 8.24668 9.60109 8.73483C10.0892 9.22299 10.3333 9.86279 10.3333 10.5026C10.3333 11.1424 10.0892 11.7822 9.60109 12.2704Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/featured-icon.7dcc44d9e44ee3407521bdfff8259d8e.svg";
export { ForwardRef as ReactComponent };